import React from "react";

export default function Marquee({ items = [] }) {
  const line = [...items, ...items];
  return (
    <section className="py-10 md:py-14 border-y hairline" style={{ background: "var(--ev-surface)" }}>
      <div className="text-center eyebrow mb-6 md:mb-8">Coaching service offered in</div>
      <div className="ev-marquee-wrap">
        <div className="ev-marquee whitespace-nowrap">
          {line.map((w, i) => (
            <span key={i} className="font-serif-ev text-3xl sm:text-4xl md:text-5xl" style={{ color: "#B7B0A5" }}>
              {w}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
